module.exports = __webpack_public_path__ + "img/800_5e04ccb351a66.0db46c26.jpg";